<template>
  <section id="home">
    <WhoIAm />
    <DesignProcess />
    <SkillSet />
  </section>
</template>

<script>
import WhoIAm from "@/components/WhoIAm";
import DesignProcess from "@/components/DesignProcess";
import SkillSet from "@/components/SkillSet";

import { EventBus } from "../main";
export default {
  components: {
    WhoIAm,
    DesignProcess,
    SkillSet
  },
  beforeMount() {
    EventBus.$emit("allLinks", document.querySelectorAll("a"));
  }
};
</script>

<style lang="scss" scoped></style>
